import {
  Mesh,
  MeshBasicMaterial,
  SphereGeometry,
} from 'three';

import { scene, camera } from './scene';
import { addToRenderLoop } from './renderLoop';
import { isDebugging } from './urlParams';

// add target
if (isDebugging) {
  const material = new MeshBasicMaterial({ color: 0xff0000 });
  const geometry = new SphereGeometry( 24, 32, 16 );
  const sphere = new Mesh(geometry, material.clone());
  scene.add(sphere);
  addToRenderLoop(() => {
    sphere.position.set(
      camera.target.x,
      camera.target.y,
      camera.target.z,
    );
  });
}
